import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Copy, History, LogIn, Users } from "lucide-react";
import { toast } from "sonner";
import { getActiveSessionCode } from "@/lib/studyApi";

export default function StudyTogetherCard() {
  const navigate = useNavigate();
  const [activeCode] = useState(getActiveSessionCode());

  const copyId = () => {
    navigator.clipboard.writeText(activeCode);
    toast.success("Session ID copied!");
  };

  return (
    <div className="bg-card border border-border rounded-2xl p-5 sm:p-6" data-testid="study-together-card">
      <div className="flex items-center gap-2 mb-3">
        <div className="w-9 h-9 rounded-xl bg-accent/15 flex items-center justify-center">
          <Users className="text-accent" size={17} />
        </div>
        <div>
          <p className="font-heading font-bold text-sm">Combine Study</p>
          <p className="text-xs text-muted-foreground">Learn live with up to 2 friends</p>
        </div>
      </div>
      {activeCode && (
        <div className="flex items-center justify-between bg-muted rounded-xl px-4 py-2.5 mb-3" data-testid="home-active-session-id">
          <div>
            <p className="text-[10px] font-bold uppercase tracking-wide text-muted-foreground">Your Session ID</p>
            <p className="font-heading font-bold tracking-wider">{activeCode}</p>
          </div>
          <button onClick={copyId} data-testid="home-copy-session-id" className="text-muted-foreground hover:text-foreground"><Copy size={16} /></button>
        </div>
      )}
      <div className="flex flex-col sm:flex-row gap-2">
        <button onClick={() => navigate("/study/create")} data-testid="home-start-study-together" className="flex-1 h-11 rounded-xl bg-primary text-primary-foreground font-bold text-sm hover:bg-primary/90 active:scale-95 transition-all">
          Start Combine Study
        </button>
        <button onClick={() => navigate("/study/join")} data-testid="home-join-a-session" className="flex-1 h-11 rounded-xl border-2 border-border font-bold text-sm flex items-center justify-center gap-1.5 hover:bg-muted">
          <LogIn size={15} /> Join a Session
        </button>
      </div>
      <button onClick={() => navigate("/study/history")} data-testid="home-study-history-link" className="mt-3 text-xs font-semibold text-muted-foreground hover:text-foreground flex items-center gap-1">
        <History size={12} /> My Combine Study Sessions
      </button>
    </div>
  );
}
